import { EquisUtilsModule } from '@tn-equis/core/utils';
import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

var EquisSwitchSide;
(function (EquisSwitchSide) {
    EquisSwitchSide["LEFT"] = "left";
    EquisSwitchSide["RIGHT"] = "right";
})(EquisSwitchSide || (EquisSwitchSide = {}));

class EquisSwitchComponent {
    constructor() {
        this.selected = false;
        this.disabled = false;
        this.switchEvents = new EventEmitter();
        this.switchSide = EquisSwitchSide.LEFT;
        this.EQUIS_SWITCH_SIDE = EquisSwitchSide;
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.propagateChange = (_) => { };
    }
    set side(side) {
        this.switchSide = Object.values(EquisSwitchSide).includes(side)
            ? side
            : EquisSwitchSide.LEFT;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleSwitch(event) {
        event.preventDefault();
        if (!this.disabled) {
            this.selected = !this.selected;
            this.propagateChange(this.selected);
            this.switchEvents.emit(this.selected);
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    writeValue(obj) {
        if (obj) {
            this.selected = obj.selected || this.selected;
            this.text = obj.text || this.text;
            this.side = obj.side || this.switchSide;
            this.id = obj.id || this.id;
            this.disabled = obj.disabled || this.disabled;
        }
    }
    registerOnTouched(fn) { }
}
EquisSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisSwitchComponent, selector: "z-switch,equis-switch", inputs: { id: "id", text: "text", side: "side", selected: "selected", disabled: "disabled" }, outputs: { switchEvents: "switchEvents" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EquisSwitchComponent),
            multi: true,
        },
    ], ngImport: i0, template: "<div class=\"switch\">\n  <label\n    class=\"switch__label switch__layout\"\n    [for]=\"id\"\n    [ngClass]=\"[\n      switchSide === EQUIS_SWITCH_SIDE.RIGHT ? 'switch__layout--right' : '',\n      disabled ? 'switch__label--disabled' : ''\n    ]\"\n    (click)=\"toggleSwitch($event)\"\n  >\n    <div class=\"switch__switch switch__layout-item\">\n      <input class=\"switch__input\" type=\"checkbox\" [id]=\"id\" />\n      <div\n        class=\"switch__slider\"\n        [ngClass]=\"[\n          disabled ? 'switch__slider--disabled' : '',\n          selected\n            ? 'switch__slider--checked switch-base'\n            : 'switch__slider--unchecked'\n        ]\"\n      ></div>\n    </div>\n    <div\n      class=\"switch__text switch__layout-item equis-body-1\"\n      [ngClass]=\"[disabled ? 'switch__text--disabled' : '']\"\n    >\n      {{ text }}\n    </div>\n  </label>\n</div>\n", styles: [".switch{display:flex;-webkit-tap-highlight-color:rgba(0,0,0,0);text-align:left}.switch--disabled{cursor:not-allowed}.switch__label{cursor:pointer}.switch__label--disabled{cursor:not-allowed}.switch__layout{display:flex;margin:0 -4px;width:calc(100% + 8px)}.switch__layout--right{flex-direction:row-reverse}.switch__layout-item{margin:0 4px}.switch__text{align-self:center;color:#333;flex-grow:1}.switch__text--disabled{color:#b2b2b2}.switch__input{position:absolute}.switch__switch{display:inline-block;flex-shrink:0;margin-bottom:2px;margin-top:2px;position:relative}.switch__slider{border-radius:200px;box-sizing:border-box;height:20px;inset:0;position:relative;transition:.3s;width:36px}.switch__slider:before{background-color:#fff;border-radius:200px;box-shadow:0 1px 2px #0000004d;content:\"\";height:16px;position:absolute;transition:.3s;width:16px}.switch__slider--unchecked{background-color:#767676;border:2px solid #767676}.switch__slider--disabled{background-color:#d1d1d1;border-color:#d1d1d1}.switch__slider--disabled:before{background-color:#fff;box-shadow:none}.switch__slider--checked{border-style:solid;border-width:2px}.switch__slider--checked:before{transform:translate(16px)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-switch,equis-switch', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => EquisSwitchComponent),
                            multi: true,
                        },
                    ], template: "<div class=\"switch\">\n  <label\n    class=\"switch__label switch__layout\"\n    [for]=\"id\"\n    [ngClass]=\"[\n      switchSide === EQUIS_SWITCH_SIDE.RIGHT ? 'switch__layout--right' : '',\n      disabled ? 'switch__label--disabled' : ''\n    ]\"\n    (click)=\"toggleSwitch($event)\"\n  >\n    <div class=\"switch__switch switch__layout-item\">\n      <input class=\"switch__input\" type=\"checkbox\" [id]=\"id\" />\n      <div\n        class=\"switch__slider\"\n        [ngClass]=\"[\n          disabled ? 'switch__slider--disabled' : '',\n          selected\n            ? 'switch__slider--checked switch-base'\n            : 'switch__slider--unchecked'\n        ]\"\n      ></div>\n    </div>\n    <div\n      class=\"switch__text switch__layout-item equis-body-1\"\n      [ngClass]=\"[disabled ? 'switch__text--disabled' : '']\"\n    >\n      {{ text }}\n    </div>\n  </label>\n</div>\n", styles: [".switch{display:flex;-webkit-tap-highlight-color:rgba(0,0,0,0);text-align:left}.switch--disabled{cursor:not-allowed}.switch__label{cursor:pointer}.switch__label--disabled{cursor:not-allowed}.switch__layout{display:flex;margin:0 -4px;width:calc(100% + 8px)}.switch__layout--right{flex-direction:row-reverse}.switch__layout-item{margin:0 4px}.switch__text{align-self:center;color:#333;flex-grow:1}.switch__text--disabled{color:#b2b2b2}.switch__input{position:absolute}.switch__switch{display:inline-block;flex-shrink:0;margin-bottom:2px;margin-top:2px;position:relative}.switch__slider{border-radius:200px;box-sizing:border-box;height:20px;inset:0;position:relative;transition:.3s;width:36px}.switch__slider:before{background-color:#fff;border-radius:200px;box-shadow:0 1px 2px #0000004d;content:\"\";height:16px;position:absolute;transition:.3s;width:16px}.switch__slider--unchecked{background-color:#767676;border:2px solid #767676}.switch__slider--disabled{background-color:#d1d1d1;border-color:#d1d1d1}.switch__slider--disabled:before{background-color:#fff;box-shadow:none}.switch__slider--checked{border-style:solid;border-width:2px}.switch__slider--checked:before{transform:translate(16px)}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], text: [{
                type: Input
            }], side: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], switchEvents: [{
                type: Output
            }] } });

class EquisSwitchModule {
    constructor() { }
    static forRoot() {
        return {
            ngModule: EquisSwitchModule,
        };
    }
}
EquisSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchModule, declarations: [EquisSwitchComponent], imports: [CommonModule, EquisUtilsModule], exports: [EquisSwitchComponent] });
EquisSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchModule, imports: [CommonModule, EquisUtilsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisSwitchComponent],
                    imports: [CommonModule, EquisUtilsModule],
                    exports: [EquisSwitchComponent],
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of equis-switch
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisSwitchComponent, EquisSwitchModule, EquisSwitchSide };
